import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Hip Hop Dance Instructor | New York, USA',
  text: "The footwork progressions completely transformed my students' development. Every week feels like a real step forward — and I'm not the one rushing to decide what that step should be."
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Hip Hop Dance Instructor | Melbourne, Australia',
  text: 'I used to get nervous every time a student from a different level joined the group. Now I open the Mixed-Level System and I have three versions of every skill ready before anyone walks in. That alone changed everything.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Hip Hop Dance Instructor | Toronto, Canada',
  text: "I review the key cues before every session and walk in knowing exactly what I'm going to say. The Cueing Library is something I use every single week without exception."
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Hip Hop Dance Instructor | London, UK',
  text: "The Emergency Class System saved my substitute session completely. I had everything organized — warm-up, technical focus, combination, cool-down — all in one place. My students didn't even notice it was a last-minute class."
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'Hip Hop Dance Instructor | Dublin, Ireland',
  text: 'The freestyle activities were a total revelation. My students talk about those sessions for weeks. They feel like a real creative experience — not just a training class.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream" data-id="element-63" data-mp="3hp63ci88h1g9">
      <div className="max-w-6xl mx-auto" data-id="element-64" data-mp="3hslj7n9qeeiq">
        <div className="text-center mb-16" data-id="element-65" data-mp="2baf6qqq582s1">
          <h2 className="text-3xl md:text-5xl font-serif font-bold uppercase text-ink" data-id="element-66" data-mp="2b82fto2eqi2u">
            What hip hop dance instructors who already have their system are
            saying:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-67" data-mp="27qetg905ge1p">
          {testimonials.map((t, i) => <motion.article key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-cream-light border border-line p-8 rounded-2xl relative shadow-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-68" data-mp="1yrjkip5q0pup" data-mpi={i}>
              <QuoteIcon className="absolute top-6 right-6 text-gold/40" size={48} data-id="element-69" data-mp="1g1usp4x61pjk" />

              <div className="flex gap-1 text-gold-dark mb-6" aria-label="5 out of 5 stars" data-id="element-70" data-mp="1k36knh3iimux">
                {[...Array(5)].map((_, j) => <StarIcon key={j} size={16} fill="currentColor" data-id="element-71" data-mp="1b0nmvbel30fj" data-mpi={j} />)}
              </div>

              <p className="text-ink-soft italic mb-8 relative z-10 leading-relaxed" data-id="element-72" data-mp="rgp122s8orpj">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-73" data-mp="mjgiw273cnoa">
                <div className="w-12 h-12 rounded-full bg-burgundy text-cream-light flex items-center justify-center font-bold text-lg" data-id="element-74" data-mp="11fxrwmrt5q7o">
                  {t.initials}
                </div>
                <div data-id="element-75" data-mp="1adq7zt5ct1w4">
                  <div className="font-bold text-ink" data-id="element-76" data-mp="1ad85wfw0ftga">{t.name}</div>
                  <div className="text-xs text-burgundy" data-id="element-77" data-mp="15ewvo41szgxj">{t.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}